import { theme } from '../../system/theme';
import { Text, Props as TextProps } from '../Text/Text';

interface Props extends Omit<TextProps, 'textColor'> {
  fromColor: string;
  toColor: string;
  /** Lightens fromColor by mixing with white. Value from 0 (no change) to 100 (full white). */
  fromColorOpacity?: number;
  /** Lightens toColor by mixing with white. Value from 0 (no change) to 100 (full white). */
  toColorOpacity?: number;
}

const lighten = (base: string, scale: number) =>
  `color-mix(in hsl, ${base} ${100 - scale}%, white)`;

export const GradientText = (props: Props) => {
  const { fromColor, toColor, fromColorOpacity, toColorOpacity, ...textProps } =
    props;
  return (
    <Text
      {...textProps}
      styles={[
        getGradientStyles(fromColor, toColor, fromColorOpacity, toColorOpacity),
      ]}
    />
  );
};

const getGradientStyles = (
  fromColor: string,
  toColor: string,
  fromColorOpacity?: number,
  toColorOpacity?: number,
) => {
  const fromBase = theme.colors[fromColor] as string;
  const toBase = theme.colors[toColor] as string;

  const from =
    fromColorOpacity !== undefined
      ? lighten(fromBase, fromColorOpacity)
      : fromBase;

  const to =
    toColorOpacity !== undefined ? lighten(toBase, toColorOpacity) : toBase;

  return {
    display: 'inline-block',
    width: 'fit-content',
    background: `linear-gradient(to right, ${from}, ${to})`,
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  };
};
